import Vue from 'vue'
import VueRouter from 'vue-router'

import { canNavigate } from '@/libs/acl/routeProtection'
import {
  isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser
} from '@/auth/utils'

import dashBoard from '@/router/routes/dashBoard'
import chat from '@/router/routes/chat'
import videoCall from '@/router/routes/videoCall'

import login from './routes/login'
import authorized from './routes/authorized'

import customer from './routes/customer/appsCustomer'
import specialist from './routes/specialist/appsSpecialist'
import admin from './routes/admin/appsAdmin'
import authentication from './routes/authentication'

Vue.use(VueRouter)
// dashboard
let caminho = ''
if (getUserData() !== null) {
  if (getUserData().role === 'customer') {
    caminho = 'principal'
  }
  if (getUserData().role === 'specialist') {
    caminho = 'dashboard'
  }
  if (getUserData().role === 'admin') {
    caminho = 'dashboard'
  }
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: `${caminho}` } },
    ...authorized,
    ...login,
    ...dashBoard,
    ...customer,
    ...specialist,
    ...admin,
    ...chat,
    ...videoCall,
    ...authentication,
    {
      path: '/termos-de-uso',
      name: 'termos-de-uso',
      component: () => import('@/views/TermosDeUso.vue'),
      meta: {
        layout: 'full',
        requiresAuth: false, // Explicitamente definindo que não requer autenticação
      },
    },
    {
      path: '/politica-de-privacidade',
      name: 'politica-de-privacidade',
      component: () => import('@/views/PoliticaPrivacidade.vue'),
      meta: {
        layout: 'full',
        requiresAuth: false, // Explicitamente definindo que não requer autenticação
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, from, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (!to.meta.requiresAuth && to.meta.requiresAuth !== undefined) {
    return next()
  }
  if (to.name !== 'login' && !isLoggedIn) {
    // Verifique se o usuário tem permissão para acessar a rota

    if (!canNavigate(to)) {
      if (!isLoggedIn) {
        return next({ name: 'login' })
      }
      return next({ name: 'authorized' })
    }
  }

  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
